export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_03.9e9bdd44.jpg";